module.exports = __webpack_public_path__ + "static/media/PEFI.8fed4b66.png";